/* eslint-disable no-useless-concat */
import { CustomTitle } from "./CustomTitle"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { BaseTable } from "../../SharedComponents/BaseTable"
import { Box } from "@material-ui/core"
import { gcfRow } from "../../../tablesInfoData/tableRows"
import { ContentLayout } from "../../SharedComponents/ContentLayout"
import { standardScrollBar } from "../../../styles"

const styles = {
  tablebox: css`
    margin-top: var(--spacing-xl);
  `,
}

type TableProps = {
  data: any
  item: any
  customTitles: string[]
  isLoading: boolean
}
export function GcfTable(props: TableProps) {
  const { t } = useI18n()

  const { data, item, customTitles, isLoading } = props

  const columnWidth = 320
  const headersGapWidth = 24

  return (
    <>
      <Box
        style={{ width: "100%", overflow: "auto" }}
        className={standardScrollBar.root}
      >
        <Box
          display="flex"
          style={{ gap: headersGapWidth, width: "fit-content" }}
        >
          <CustomTitle title="" hideBorder customWidth={100} />
          {customTitles.map((t, index) => {
            return <CustomTitle key={index} title={<div>{t}</div>} />
          })}
        </Box>
        <ContentLayout maxHeight="500px" customClass={styles.tablebox}>
          <BaseTable
            rows={gcfRow(t, item.key)}
            data={data?.data[item.key as keyof typeof data.data]}
            isLoading={isLoading}
            columnWidth={columnWidth + headersGapWidth}
            gap={headersGapWidth}
            cellsPerColumn={2}
            total={data?.total[item.key as keyof typeof data.data]}
          />
        </ContentLayout>
      </Box>
    </>
  )
}
